import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { AppConstants } from '@app/@shared/app.constants';
import { SessionStorageService } from '@app/sessionStorage.service';
import { AnalyticsService } from '@app/@shared/services/analytics.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private currentUsersSubject: BehaviorSubject<any>;
  private currentUser: Observable<any>;

  constructor(
    private http: HttpClient,
    private router: Router,
    private storageService: SessionStorageService,
    private analyticsService: AnalyticsService
  ) {
    this.currentUsersSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('currentUser') || '{}'));
    this.currentUser = this.currentUsersSubject.asObservable();
  }

  get currentUserValue(): any {
    return this.currentUsersSubject.value;
  }

  login(email: string, password: string): Observable<any> {
    return this.http.post<any>(AppConstants.LOGIN_URL, { email, password }).pipe(
      tap((user) => {
        this.storeCurrentUser(user);
      }),
    );
  }

  loginWithConfirmationToken(token: string): Observable<any> {
    return this.http.post<any>(AppConstants.CONFIRMATION_LOGIN_URL, { token }).pipe(
      tap((user) => {
        this.storeCurrentUser(user);
      }),
    );
  }

  verifyOTP(phoneNumber: string, otp: string): Observable<any> {
    return this.http.post<any>(AppConstants.VERIFY_OTP_URL, { phoneNumber, code: otp }).pipe(
      tap((user) => {
        this.storeCurrentUser(user);
      }),
    );
  }

  logOut(route=['/']) {
    // Reset Mixpanel identity before clearing storage
    this.analyticsService.resetIdentity();
    
    localStorage.clear();
    sessionStorage.clear();
    this.storageService.clearData();
    this.currentUsersSubject.next(null);
    // Clear service worker cache
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }
    this.router.navigate(route);
  }
  clearLogs() {
    localStorage.clear();
    sessionStorage.clear();
    this.currentUsersSubject.next(null);
    // Clear service worker cache
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }
    // this.router.navigate(['/']);
  }

  getrefreshToken(): Observable<any> {
    const refreshToken = this.currentUserValue?.refreshToken;
    if (!refreshToken) {
      return throwError(() => 'No refresh token available');
    }
    return this.http.post(AppConstants.REFRESH_TOKEN_URL, { refreshToken }).pipe(
      tap((user) => {
        this.storeCurrentUser(user);
      }),
    );
  }

  private storeCurrentUser(user: any): void {
    localStorage.setItem('currentUser', JSON.stringify(user));
    this.currentUsersSubject.next(user);
  }
}
